import styled from 'styled-components'
import Trash from 'static/icons/trash.svg'
import Card from '../forms/card'

export const CardWrapper = styled(Card)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
`

export const CouponInfo = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
`

export const CouponTitle = styled.div`
  h2 {
    font-size: 14px;
    font-weight: 600;
    color: var(--gray-2);
  }

  h3 {
    font-size: 12px;
    font-weight: 400;
    color: var(--gray-5);
  }
`

export const TrashIcon = styled(Trash)`
  cursor: pointer;
`
